import React, { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import CardDisplay from './CardDisplay';
import { Svgs } from '../assets/svg';
import { InputAdornment, useTheme } from '@mui/material';

interface DatePickerProps {
  initialDate?: Dayjs | null;
  onDateChange: (date: Dayjs | null) => void;
  minDate?: Dayjs | null;
  maxDate?: Dayjs | null;
}

const CardDatePicker: React.FC<DatePickerProps> = ({
  initialDate = dayjs(),
  onDateChange,
  minDate,
  maxDate,
}) => {
  const theme = useTheme();
  const [date, setDate] = useState<Dayjs | null>(initialDate);
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    onDateChange(date);
  }, [date, onDateChange]);

  const onChange = (newDate: Dayjs | null) => {
    setDate(newDate);
    setTimeout(() => setOpen(false), 0);
  };

  const onClickCard = () => {
    if (open) return;
    setOpen(true);
  };

  const onOpen = () => setOpen(true);

  const onClose = () => setOpen(false);

  return (
    <CardDisplay
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        boxSizing: 'border-box',
        maxHeight: theme.spacing(8),
      }}
      onClick={onClickCard}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          className='date-picker'
          open={open}
          value={date}
          format='MM/DD/YYYY'
          minDate={minDate || undefined}
          maxDate={maxDate || undefined}
          onOpen={onOpen}
          onClose={onClose}
          onChange={onChange}
          slots={{
            openPickerIcon: () => null,
            inputAdornment: () => null,
          }}
          slotProps={{
            textField: {
              readOnly: true,
              InputProps: {
                startAdornment: (
                  <InputAdornment position='start'>
                    <Svgs.ActionSmallCalendarDefault />
                  </InputAdornment>
                ),
              },
              sx: {
                '& .MuiInputBase-root': {
                  maxWidth: theme.spacing(15),
                },
                '& .MuiPickersOutlinedInput-notchedOutline': {
                  border: 'none !important',
                },
                '& .MuiPickersSectionList-root': {
                  width: 'auto',
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    </CardDisplay>
  );
};

export default CardDatePicker;
